module.exports = __webpack_public_path__ + "img/projects-two-1.f6169799.jpg";